export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13504.12cc7191.jpg";